<div class="login-help suif-panel">
    <h1 class="suif-panel-title-dark">Help Signing In</h1>
    <div class="suif-lead-paragraph">
        Did you forget your password or lose access to your email?
    </div>
    <app-radio-group
            [(ngModel)]="selection"
            [list]="helpOptions"
            code="stateName"
            direction="column"></app-radio-group>
    <div class="button-row">
        <button class="btn btn-secondary" type="button" routerLink="/login">Cancel</button>
        <button class="btn btn-verty" [routerLink]="selection" [disabled]="!selection">Continue</button>
    </div>
</div>
